import { useEffect, useRef, useState } from "react";

const BUTTON_MAP = {
  12: "up",
  13: "down",
  14: "left",
  15: "right",
};

const useGamepad = ({ enabled, onDirection }) => {
  const [connected, setConnected] = useState(false);
  const prevButtonsRef = useRef({});

  useEffect(() => {
    if (!enabled || typeof navigator === "undefined") {
      setConnected(false);
      return undefined;
    }

    const interval = setInterval(() => {
      const pads = navigator.getGamepads ? navigator.getGamepads() : [];
      const pad = pads ? Array.from(pads).find(Boolean) : null;
      setConnected(Boolean(pad));
      if (!pad) {
        return;
      }

      pad.buttons.forEach((button, index) => {
        const direction = BUTTON_MAP[index];
        if (!direction) {
          return;
        }
        const wasPressed = prevButtonsRef.current[index] || false;
        if (button.pressed && !wasPressed) {
          onDirection(direction);
        }
        prevButtonsRef.current[index] = button.pressed;
      });
    }, 120);

    return () => clearInterval(interval);
  }, [enabled, onDirection]);

  return { connected };
};

export default useGamepad;